import { render, staticRenderFns } from "./Stp.vue?vue&type=template&id=2019e1a2&"
import script from "./Stp.vue?vue&type=script&lang=js&"
export * from "./Stp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports